export const _LEGACY_MEDICATIONS_ACTIVE_STATUSES = ['active', 'intended'];
export const _LEGACY_ENUMS_MEDICATIONS_STATUSES = {
    active: {
        id: 'active',
        tKey: 'enums.medications.active',
        tKeyDesc: 'enums.medications.active.additional_text',
    },
    completed: {
        id: 'completed',
        tKey: 'enums.medications.completed',
        tKeyDesc: 'enums.medications.completed.additional_text',
    },
    'entered-in-error': {
        id: 'entered-in-error',
        tKey: 'enums.medications.entered_in_error',
        tKeyDesc: 'enums.medications.entered_in_error.additional_text',
    },
    intended: {
        id: 'intended',
        tKey: 'enums.medications.intended',
        tKeyDesc: 'enums.medications.intended.additional_text',
    },
    stopped: {
        id: 'stopped',
        tKey: 'enums.medications.stopped',
        tKeyDesc: 'enums.medications.stopped.additional_text',
    },
    'on-hold': {
        id: 'on-hold',
        tKey: 'enums.medications.on_hold',
        tKeyDesc: 'enums.medications.on_hold.additional_text',
    },
    unknown: {
        id: 'unknown',
        tKey: 'enums.medications.unknown',
        tKeyDesc: 'enums.medications.unknown.additional_text',
    },
    'not-taken': {
        id: 'not-taken',
        tKey: 'enums.medications.not_taken',
        tKeyDesc: 'enums.medications.not_taken.additional_text',
    },
};
